


/** @format */

import { Vue, Component } from 'vue-property-decorator';
@Component
export default class businessMixin extends Vue {
  log?: Function;
  viewImageModelData: {} = {}; //查看图片所使用的视图数据// 查看图片弹框
  showReviewImgModel: boolean = false;

  /**
   * 车牌号组件发生变化
   */
  // plateChange([plateHead, plateTail]: any) {
  //   let httpKeys = this.UI.TableFilter.items.find(item => item.comp == 'TableFilterItem.PlateInput').attrs.httpKey
  //   this.filterParam[httpKeys[0]] = plateHead
  //   this.filterParam[httpKeys[1]] = plateTail
  // }
  /**
   * 车牌号组件发生变化
   */
  plateChange([plateHead, plateTail]: any) {
    this.log('plate change--:', plateHead, plateTail);
    this.filterParam.plateHead = plateHead;
    this.filterParam.plateTail = plateTail;
  }

  mounted() {
    this.evtBus.$on('B_TABLE_FILTER_CLEAR', () => {
      if (this.getPageTypeByJSONDesc()) {
        for (var i in this.$refs) {
          [].concat(this.$refs[i]).forEach(childVM => {
            if (typeof childVM.clearValue === 'function') {
              childVM.clearValue();
            }
          });
        }
        // this.$refs.dynamicComp.forEach(childVM => {
        //   childVM.clearValue()
        // })
      }
    });
  }

  // dynamicComponentAttrs(compDefine) {
  //   let attrs = compDefine.attrs || {}

  //   if (!compDefine.comp.split('.').reverse()[0] == 'aRangePicker') {
  //     attrs.value = 'initialValue' in compDefine ? compDefine.initialValue : this.filterParam[compDefine.attrs.httpKey]
  //   }
  //   return attrs
  // }

  //搜索之前校验搜索区域的验证
  private validateBeforeSearch = () => {
    if (
      'plateTail' in this.filterParam &&
      (this.filterParam.plateTail || '').trim() !== '' &&
      (this.filterParam.plateHead || '').trim() === ''
    ) {
      this.$message.warning('请选择车牌头');
      return false;
    }
  };

  //从model中获取字典值对应的label，字典值一般可以转换为整型，无法转换则说明本身不是整型
  getLabelByPropFromModel(prop: any, model: Object, enumLabels: []) {
    if (Number.isInteger(model[prop] - 0)) {
      return enumLabels[model[prop] - 0];
    } else {
      return model[prop];
    }
  }

  beforeCreate() {
    if (!this.log) {
      this.log = () => {};
    }
  }

  //生成调用了fieldInfoList组件的详情弹出框等组件里的图片渲染函数
  getImgRenderFunInDetailDialog(basicInfo, prop = 'img') {
    console.log('prop===>', prop);
    console.log('basicInfo', basicInfo);
    let imgNode = basicInfo.fields.find((item: { prop: string }) => item.prop === prop);
    if (!imgNode) {
      console.log('木有图片节点');
      return false;
    }
    imgNode.render = (
      c: (
        arg0: string,
        arg1: { attrs: { src: any }; on: { click: any; error: any }; style: { 'max-width': string } }
      ) => any
    ) => {
      return c('img', {
        attrs: {
          src: this.$API_SERVER.imgBaseUrl + basicInfo.data[imgNode.prop]
        },
        on: {
          click: () => {
            this.reviewImages(basicInfo.data);
          },
          error: e => {
            e.target.setAttribute('src', this.$API_SERVER.defaultImg);
          }
        },
        style: {
          'max-width': '50%'
        }
      });
    };
  }
}
